import { Component } from '@angular/core';
import { PzService } from '../../service/pz.service';
import { MatchResults, StatsService } from '../../service/stats.service';
import {
  GENERAL_ERROR_SUMMARY,
  GENERAL_SUCCESS_SUMMARY,
} from '../../utils/error-handler';
import { NotificationService } from '../../service/notification.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
})
export class AdminComponent {
  constructor(
    public pzService: PzService,
    public statsService: StatsService,
    public notificationService: NotificationService
  ) {}

  public async saveResult(): Promise<void> {
    const data: MatchResults = await lastValueFrom(
      this.statsService.getStats()
    );

    data.matches.push({
      date: new Date().toISOString().substring(0, 10),
      player1: this.pzService.model.pointsPlayer1,
      player2: this.pzService.model.pointsPlayer2,
    });

    try {
      await lastValueFrom(this.statsService.setStats(data));
      this.notificationService.showSuccess(
        GENERAL_SUCCESS_SUMMARY,
        'Ergebnis erfolgreich gespeichert.'
      );
    } catch (err: any) {
      console.error('Could not save result on server', err);
      this.notificationService.showError(
        GENERAL_ERROR_SUMMARY,
        'Ergebnis konnte nicht gespeichert werden.'
      );
    }
  }
}
